/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="115.14" height="59.49" viewBox="0 0 115.14 59.49" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M33.85,48.09A1.25,1.25,0,0,1,34,50.58H13.25a1.25,1.25,0,0,1-.13-2.5H33.85Z" transform="translate(-12 -47.91)" fill="#ffb81c"/><path d="M29.88,60A1.25,1.25,0,0,1,30,62.51H13.25A1.25,1.25,0,0,1,13.12,60H29.88Z" transform="translate(-12 -47.91)" fill="#ffb81c"/><path d="M25.33,71.76a1.25,1.25,0,0,1,.13,2.49H13.25a1.25,1.25,0,0,1-.13-2.49H25.33Z" transform="translate(-12 -47.91)" fill="#ffb81c"/><path d="M19.29,83.41a1.25,1.25,0,0,1,.13,2.49H13.25a1.25,1.25,0,0,1-.13-2.5h6.17Z" transform="translate(-12 -47.91)" fill="#ffb81c"/><path d="M122.69,47.91H46.93a4.45,4.45,0,0,0-4.41,3.85l-7,50.58A4.45,4.45,0,0,0,40,107.4h75.76a4.46,4.46,0,0,0,4.41-3.85l7-50.58A4.46,4.46,0,0,0,122.69,47.91Zm-75.76,2.5h75.76a2,2,0,0,1,1.93,2.22l-7,50.58a2,2,0,0,1-1.93,1.69H40A2,2,0,0,1,38,102.68L45,52.1A1.94,1.94,0,0,1,46.93,50.41Z" transform="translate(-12 -47.91)" fill="#0e497b"/><path d="M45,48.27,79.55,81.8l44.71-32.65,1.47,2L80.18,84.44a1.26,1.26,0,0,1-1.51,0l-.1-.09L43.27,50.06Z" transform="translate(-12 -47.91)" fill="#0e497b"/><polygon points="74.89 29.71 105.82 56 104.2 57.91 73.27 31.62 74.89 29.71" fill="#0e497b"/><polygon points="62.37 29.32 63.83 31.36 26.81 57.97 25.35 55.94 62.37 29.32" fill="#0e497b"/>
</svg>

    );
  }
}

Icon.displayName = 'EnvelopeMovingIcon';

export default Icon;
